import { Drawer, Button } from '@mui/material';
import IcClose from '../../assets/image/ic_x.svg';
import { TALENT_ARR } from '../../data/define';
import IcCheckMintOn from '../../assets/image/ic_check_mint_on.svg';
import IcCheckOff from '../../assets/image/ic_check_off.svg';
import IcLanguage from '../../assets/image/intelligence/ic_language.svg';
import IcMusic from '../../assets/image/intelligence/ic_music.svg';
import IcPhysical from '../../assets/image/intelligence/ic_physical.svg';
import IcMath from '../../assets/image/intelligence/ic_math.svg';
import IcSpace from '../../assets/image/intelligence/ic_space.svg';
import IcRelationship from '../../assets/image/intelligence/ic_relationship.svg';
import IcReflection from '../../assets/image/intelligence/ic_reflection.svg';
import IcNature from '../../assets/image/intelligence/ic_nature.svg';
import { useTranslation } from '../../hook/useTranslation';

function IntelligenceChoiceDialog({
  open,
  onClose = () => {},
  handleConfirm = () => {},
  intelligences = [],
  setIntelligences,
}: {
  open: boolean;
  onClose?: () => void;
  handleConfirm?: () => void;
  intelligences: number[];
  setIntelligences: React.Dispatch<React.SetStateAction<number[]>>;
}) {
  const { t } = useTranslation();
  return (
    <Drawer
      open={open}
      anchor="bottom"
      onClose={(event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (reason === 'backdropClick') return;
        if (onClose) (onClose as any)(event, reason);
      }}
      PaperProps={{ sx: { borderRadius: '10px 10px 0 0', minHeight: '80vh' } }}
    >
      <div className="w-full p-5 min-h-[200px] text-[#1C1C1C] font-['Pretendard'] flex flex-col items-center justify-between bg-white overflow-hidden h-[80vh]">
        <div className="w-full flex justify-between items-center mb-3 absolute top-5 left-0 px-5 z-[9999]">
          <div className="text-[#1C1C1C] font-[700] text-[20px] text-left">{t('upload.intelligence_choice.title')}</div>
          <button
            type="button"
            onClick={onClose}
            className="w-[24px] h-[24px] flex items-center justify-center cursor-pointer"
          >
            <img src={IcClose} alt="Close" />
          </button>
        </div>
        <div className="w-full mt-[36px] overflow-y-auto" style={{ height: 'calc(80vh - 120px)' }}>
          <div className="flex flex-col gap-2 mt-[12px] mb-[12px]">
            {TALENT_ARR.map((item) => {
              let icon;
              switch (item.id) {
                case 1:
                  icon = IcLanguage;
                  break;
                case 2:
                  icon = IcMusic;
                  break;
                case 3:
                  icon = IcPhysical;
                  break;
                case 4:
                  icon = IcMath;
                  break;
                case 5:
                  icon = IcSpace;
                  break;
                case 6:
                  icon = IcRelationship;
                  break;
                case 7:
                  icon = IcReflection;
                  break;
                case 8:
                  icon = IcNature;
                  break;
                default:
                  icon = null;
                  break;
              }
              const isChecked = intelligences.includes(item.id);

              return (
                <div
                  key={item.id}
                  className="w-full rounded-[16px] bg-[#F8F8F8] flex flex-col items-center justify-start"
                >
                  <button
                    type="button"
                    className="w-full p-4 flex justify-between items-center bg-[#F8F8F8] rounded-[16px]"
                    onClick={() => {
                      if (isChecked) {
                        setIntelligences(intelligences.filter((id) => id !== item.id));
                      } else {
                        setIntelligences([item.id]);
                      }
                    }}
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-[44px] h-[44px] bg-[#fff] border border-[#EAEAEA] rounded-[10px] flex items-center justify-center">
                        <img src={icon} alt="Icon" className="w-[19px] h-[21px]" />
                      </div>
                      <div className="text-[16px] font-[700] text-[#1C1C1C] text-left">
                        {t(`talent.${item.key}`)}
                      </div>
                    </div>
                    <img
                      src={isChecked ? IcCheckMintOn : IcCheckOff}
                      alt="Check"
                      className="w-[24px] h-[24px]"
                    />
                  </button>

                  <div
                    className={`w-full overflow-hidden transition-all duration-300 ease-in-out px-4 ${
                      isChecked ? 'max-h-[300px] opacity-100 mb-4' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="w-full text-left text-[14px] text-[#363636] flex flex-col items-start justify-start gap-1 pb-4 border-b border-[#EAEAEA]">
                      <div>{t(`talent.${item.key}.q1`).split('\n').map((line, i) => (
                        <span key={i}>
                          {line}
                          {i === 0 && <br />}
                        </span>
                      ))}</div>
                      <div className="my-[4px]" />
                      <div>{t(`talent.${item.key}.q2`).split('\n').map((line, i) => (
                        <span key={i}>
                          {line}
                          {i === 0 && <br />}
                        </span>
                      ))}</div>
                      <div className="my-[4px]" />
                      <div>{t(`talent.${item.key}.q3`).split('\n').map((line, i) => (
                        <span key={i}>
                          {line}
                          {i === 0 && <br />}
                        </span>
                      ))}</div>
                      <div className="my-[4px]" />
                      <div>{t(`talent.${item.key}.q4`).split('\n').map((line, i) => (
                        <span key={i}>
                          {line}
                          {i === 0 && <br />}
                        </span>
                      ))}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="text-[14px] text-[#363636] font-[400] text-center mb-[20px]">
            {t('upload.intelligence_choice.desc_line1')}
            <br />
            {t('upload.intelligence_choice.desc_line2')}
          </div>
        </div>
        <div className="absolute bottom-5 left-0 px-5 w-full">
          <Button
            variant="contained"
            className="w-full mt-4"
            disabled={intelligences.length === 0}
            onClick={handleConfirm}
          >
            {t('upload.caution.confirm_btn')}
          </Button>
        </div>
      </div>
    </Drawer>
  );
}

export default IntelligenceChoiceDialog;
